export default function handlerErrorMP(errorSource) {
  let detail = "";
  let method = "cartão";

  if (typeof errorSource === 'string') {
    detail = errorSource;
  } else if (errorSource && typeof errorSource === 'object') {
    detail = errorSource.code || errorSource.detail || errorSource.detalhe || errorSource.message || "";
    method = errorSource.methodPayment || "cartão";
  }

  const errors = {
    // Erros de Infraestrutura / SSL (Baseados em texto)
    'SSL certificate is required': 'Erro de segurança: O checkout do Mercado Pago exige uma conexão HTTPS segura.',
    'payment cannot be processed': 'O pagamento não pode ser processado devido a uma restrição de segurança ou conexão.',
    'vencimento expirado': 'O lote está com a data de vencimento expirado.',

    // Respostas de Transação (Rejeições)
    'pending_contingency': 'O pagamento esta em analise, pela emissora do cartão',
    'cc_rejected_bad_filled_card_number': 'Revise o número do cartão.',
    'cc_rejected_bad_filled_date': 'Revise a data de vencimento.',
    'cc_rejected_bad_filled_other': 'Revise os dados informados.',
    'cc_rejected_bad_filled_security_code': 'Revise o código de segurança.',
    'cc_rejected_blacklist': 'Não pudemos processar seu pagamento no momento.',
    'cc_rejected_call_for_authorize': `Você deve autorizar o pagamento junto ao ${method}.`,
    'cc_rejected_card_disabled': `Ligue para o ${method} para ativar seu cartão.`,
    'cc_rejected_card_error': 'Não conseguimos processar seu pagamento.',
    'cc_rejected_duplicated_payment': 'Pagamento duplicado. Se precisar pagar novamente, use outro método.',
    'cc_rejected_high_risk': 'Escolha outra forma de pagamento por motivos de segurança.',
    'cc_rejected_insufficient_amount': `O ${method} possui saldo insuficiente.`,
    'cc_rejected_invalid_installments': `O ${method} não aceita o parcelamento escolhido.`,
    'cc_rejected_max_attempts': 'Limite de tentativas atingido. Tente outro cartão.',
    'cc_rejected_card_type_not_allowed': 'O cartão não possui a função crédito habilitada.',
    'expired': 'Expirado',

    // Erros de Inserção / Validação (Códigos)
    '205': 'Digite o número do seu cartão.',
    '208': 'Escolha um mês.',
    '209': 'Escolha um ano.',
    '212': 'Informe seu documento.',
    '214': 'Informe seu documento.',
    '220': 'Informe seu banco emissor.',
    '221': 'Digite o nome completo do titular.',
    '224': 'Digite o código de segurança.',
    'E203': 'Confira o código de segurança.',
    'E301': 'Número de cartão inválido. Digite novamente.',
    '316': 'Por favor, digite um nome válido.',
    '322': 'Documento inválido.',
    '324': 'Documento inválido.',
    '325': 'Data de validade inválida.',
    '326': 'Data de validade inválida.',
    'unexpected_error': 'Ocorreu um erro inesperado.',
  };

  if (errors[detail]) {
    return errors[detail];
  }

  let msg = detail ? `Erro: ${detail}` : "Não foi possível processar o pagamento.";
  const technicallErrors = Object.keys(errors).filter(key => key.length > 5);
  technicallErrors.forEach(key => {
    if (String(detail).includes(key)) {
      msg = errors[key];
    }
  });

  return msg;
}
